// extracted by mini-css-extract-plugin
var _1 = "TableControlButtons-moduleTableControlButtons__yCMIv";
var _2 = "TableControlButtons-modulegroup___8Azg";
export { _1 as "TableControlButtons", _2 as "group" }
